import { capitalize } from 'lodash';
import { Badge } from '@optiaxiom/react';

import { ExecutionStatus } from '@frontend/types/agentExecution';

type StatusCellProps = {
  status: ExecutionStatus;
};

const getStatusBadgeIntent = (status: ExecutionStatus) => {
  switch (status.toLowerCase()) {
    case 'completed':
      return 'success';
    case 'failed':
      return 'danger';
    case 'running':
    case 'pending':
      return 'warning';
    default:
      return 'neutral';
  }
};

export function StatusCell({ status }: StatusCellProps) {
  return (
    <Badge intent={getStatusBadgeIntent(status)}>
      {status.toLowerCase() === 'pending' ? 'Running' : capitalize(status)}
    </Badge>
  );
}
